import type { UserId } from '@cyphex/types/common';

/** Query keys for the people/profile surfaces. Never inline these arrays. */
export const PEOPLE_KEYS = {
  all: ['people'] as const,
  profile: (userId: UserId) => ['people', 'profile', userId] as const,
  availability: (userId: UserId) => ['people', 'availability', userId] as const,
} as const;
